// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { NotificationQuery } from './notification-query';
import { NotificationSendLog } from './notification-send-log';
import { NotificationTemplate } from './notification-template';
import { NotificationEventEnum } from './enums';
import { NotificationQueryEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class NotificationEvent extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Enum key */
  id!: NotificationEventEnum;
  /** String(250) */
  description?: string;
  /** String(60) */
  name!: string;
  /** Enum FK notificationQuery */
  notificationQueryId!: NotificationQueryEnum;
  /** FK notificationQueryId */
  notificationQuery!: NotificationQuery;
  /** Inv FK notificationEventId */
  notificationSendLogs!: NotificationSendLog[];
  /** Inv FK notificationEventId */
  notificationTemplates!: NotificationTemplate[];
}

